import './styles.css';

function announce(message: string): void {
  const region = document.querySelector<HTMLElement>('[data-live-region]');
  if (region) region.textContent = message;
}


function cleanupOneTimeQueryFlags(): void {
  const url = new URL(window.location.href);
  let changed = false;
  for (const key of ['sent', 'message']) {
    if (url.searchParams.has(key)) { url.searchParams.delete(key); changed = true; }
  }
  if (changed) window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
}

function setupCopyButtons(): void {
  document.querySelectorAll<HTMLButtonElement>('[data-copy]').forEach((button) => {
    button.addEventListener('click', async () => {
      const value = button.dataset.copy ?? '';
      if (!value) return;
      try {
        await navigator.clipboard.writeText(value);
        const original = button.textContent;
        button.textContent = 'Скопировано';
        announce('Ссылка скопирована.');
        window.setTimeout(() => { button.textContent = original; }, 1800);
      } catch {
        const field = button.parentElement?.querySelector<HTMLInputElement>('.copy-field');
        field?.select();
        announce('Выделите ссылку и скопируйте её вручную.');
      }
    });
  });
}

function setupDocumentFiles(): void {
  document.querySelectorAll<HTMLFormElement>('.file-data-form').forEach((form) => {
    const fileInput = form.querySelector<HTMLInputElement>('.file-input');
    const fileName = form.querySelector<HTMLInputElement>('input[name="fileName"]');
    const mimeType = form.querySelector<HTMLInputElement>('input[name="mimeType"]');
    const fileData = form.querySelector<HTMLInputElement>('input[name="fileData"]');
    const status = form.querySelector<HTMLElement>('.file-status');
    if (!fileInput || !fileName || !mimeType || !fileData || !status) return;

    fileInput.addEventListener('change', () => {
      const file = fileInput.files?.[0];
      if (!file) {
        fileName.value = '';
        mimeType.value = '';
        fileData.value = '';
        status.textContent = 'Файл не выбран.';
        return;
      }
      const maxBytes = Number(form.dataset.maxFileBytes ?? 1024 * 1024);
      if (file.size > maxBytes) {
        fileInput.value = '';
        status.textContent = `Файл больше ${Math.max(1, Math.floor(maxBytes / 1024 / 1024))} МБ. Выберите файл меньшего размера.`;
        status.classList.add('form-error');
        return;
      }
      status.classList.remove('form-error');
      status.textContent = 'Подготавливаем файл…';
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        const result = typeof reader.result === 'string' ? reader.result : '';
        fileName.value = file.name;
        mimeType.value = file.type || 'application/octet-stream';
        fileData.value = result;
        status.textContent = `${file.name} · ${Math.ceil(file.size / 1024)} КБ`;
      });
      reader.addEventListener('error', () => {
        status.textContent = 'Не удалось прочитать файл.';
        status.classList.add('form-error');
      });
      reader.readAsDataURL(file);
    });
  });
}





function setupPlatformDigitalEditor(): void {
  document.querySelectorAll<HTMLElement>('[data-platform-digital-editor]').forEach((editor) => {
    const form = editor.closest<HTMLFormElement>('form');
    const type = form?.querySelector<HTMLSelectElement>('select[name="type"]');
    if (!form || !type) return;
    const help=form.querySelector<HTMLElement>('[data-platform-offer-type-help]');
    const deliveryLabel=form.querySelector<HTMLElement>('[data-platform-delivery-label]');
    const descriptions:Record<string,string>={service:'Услуга: опишите результат, формат работы и что получает покупатель.',digital:'Цифровой материал: добавьте файл, условия использования и возврата. Файл выдаётся после оплаты.',education:'Обучение: укажите формат, длительность, программу и условия доступа.',equipment:'Оборудование: укажите комплектацию, состояние, доставку и гарантийные условия.',event:'Событие: укажите дату, формат участия, место или ссылку и условия регистрации.',franchise:'Готовое направление: опишите состав решения, сопровождение и условия передачи материалов.'};
    const deliveryLabels:Record<string,string>={service:'Как оказывается услуга',digital:'Как покупатель получает доступ',education:'Формат и доступ к обучению',equipment:'Условия доставки / получения',event:'Формат участия и получение доступа',franchise:'Условия получения решения'};
    const sync = () => {
      const active = type.value === 'digital';
      editor.hidden = !active;
      editor.querySelectorAll<HTMLTextAreaElement>('[data-platform-digital-field]').forEach((field) => { field.disabled = !active; field.required = active; });
      if(help)help.textContent=descriptions[type.value]??'';
      if(deliveryLabel)deliveryLabel.textContent=deliveryLabels[type.value]??'Условия получения';
    };
    type.addEventListener('change', sync);
    sync();
  });
}

function setupListingPricing(): void {
  document.querySelectorAll<HTMLSelectElement>('select[data-price-mode]').forEach((mode) => {
    const form=mode.closest<HTMLFormElement>('form');if(!form)return;
    const type=form.querySelector<HTMLSelectElement>('select[name="type"]');
    const price=form.querySelector<HTMLInputElement>('input[name="priceRub"]');
    const help=form.querySelector<HTMLElement>('[data-price-help]');
    if(!price)return;
    const sync=()=>{
      const digital=type?.value==='digital';
      const fromOption=mode.querySelector<HTMLOptionElement>('option[value="from"]');
      const requestOption=mode.querySelector<HTMLOptionElement>('option[value="request"]');
      if(digital)mode.value='fixed';
      if(fromOption)fromOption.disabled=digital;if(requestOption)requestOption.disabled=digital;
      const priced=mode.value!=='request';
      price.disabled=!priced;price.required=priced;price.min='1';
      if(help)help.textContent=digital?'Для цифрового материала используется фиксированная цена: после оплаты покупатель получает доступ по правилам цифрового продукта.':mode.value==='fixed'?'Фиксированная цена открывает прямое оформление заказа. Деньги за предложения сторонних продавцов площадка не принимает.':mode.value==='from'?'Покупатель увидит цену «от» и сначала запросит условия.':'Цена не показывается числом: покупатель сначала запросит условия.';
    };
    mode.addEventListener('change',sync);type?.addEventListener('change',sync);sync();
  });
}

function setupSellerDigitalEditor(): void {
  document.querySelectorAll<HTMLElement>('[data-digital-editor]').forEach((editor) => {
    const form = editor.closest('form');
    const type = form?.querySelector<HTMLSelectElement>('select[name="type"]');
    if (!type) return;
    const sync = () => {
      const active = type.value === 'digital';
      editor.hidden = !active;
      editor.querySelectorAll<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>('[name="licenseTerms"],[name="refundTerms"],[name="paymentInstructions"],[name="accessDays"]').forEach((field) => {
        field.disabled = !active;
        if (field instanceof HTMLTextAreaElement) field.required = active;
      });
    };
    type.addEventListener('change', sync);
    sync();
  });
}

function setupSellerDigitalVersionUpload(): void {
  document.querySelectorAll<HTMLElement>('[data-seller-digital-version-upload]').forEach((container) => {
    const input = container.querySelector<HTMLInputElement>('input[type="file"]');
    const button = container.querySelector<HTMLButtonElement>('[data-upload-digital-version]');
    const status = container.querySelector<HTMLElement>('.file-status');
    const csrf = container.dataset.csrf ?? '';
    const listingId = container.dataset.listingId ?? '';
    if (!input || !button || !status || !csrf || !listingId) return;
    const allowed = new Map<string,string>([
      ['pdf','application/pdf'],['zip','application/zip'],
      ['docx','application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
      ['xlsx','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
      ['pptx','application/vnd.openxmlformats-officedocument.presentationml.presentation'],['txt','text/plain']
    ]);
    button.addEventListener('click', async () => {
      const file = input.files?.[0];
      if (!file) { status.textContent = 'Выберите файл.'; status.classList.add('form-error'); return; }
      const ext = file.name.includes('.') ? file.name.split('.').pop()!.toLowerCase() : '';
      if (!allowed.has(ext) || allowed.get(ext) !== file.type) { status.textContent = 'Разрешены PDF, ZIP, DOCX, XLSX, PPTX и TXT с корректным типом файла.'; status.classList.add('form-error'); return; }
      if (file.size < 1 || file.size > 20 * 1024 * 1024) { status.textContent = 'Размер файла должен быть от 1 байта до 20 МБ.'; status.classList.add('form-error'); return; }
      status.classList.remove('form-error'); status.textContent = `Проверяем и загружаем ${file.name}…`; button.disabled = true;
      try {
        const response = await fetch(`/seller/listings/${encodeURIComponent(listingId)}/digital-version`, { method: 'POST', headers: { 'Content-Type': file.type, 'X-CSRF-Token': csrf, 'X-File-Name': encodeURIComponent(file.name) }, body: file });
        const payload = await response.json() as {ok?:boolean;error?:string;version?:{versionNo:number}};
        if (!response.ok || !payload.ok) throw new Error(payload.error || `HTTP ${response.status}`);
        status.textContent = `Версия ${payload.version?.versionNo ?? ''} сохранена и прошла проверку.`;
        announce('Новая версия цифрового файла сохранена.');
        window.setTimeout(() => window.location.reload(), 700);
      } catch (error) { status.textContent = error instanceof Error ? error.message : 'Не удалось загрузить файл.'; status.classList.add('form-error'); button.disabled = false; }
    });
  });
}

function validateDigitalFile(file:File,maxMb:number):string | undefined {
  const allowed=new Map<string,string>([
    ['pdf','application/pdf'],['zip','application/zip'],
    ['docx','application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['xlsx','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['pptx','application/vnd.openxmlformats-officedocument.presentationml.presentation'],['txt','text/plain']
  ]);
  const ext=file.name.includes('.')?file.name.split('.').pop()!.toLowerCase():'';
  if(!allowed.has(ext)||allowed.get(ext)!==file.type)return 'Разрешены PDF, ZIP, DOCX, XLSX, PPTX и TXT с корректным типом файла.';
  if(file.size<1||file.size>maxMb*1024*1024)return `Размер файла должен быть от 1 байта до ${maxMb} МБ.`;
  return undefined;
}

function encodedForm(form:HTMLFormElement):URLSearchParams {
  const params=new URLSearchParams();
  for(const [key,value] of new FormData(form).entries())if(typeof value==='string')params.append(key,value);
  return params;
}

function setupSellerDigitalInitialFlow():void {
  document.querySelectorAll<HTMLFormElement>('form[data-seller-listing-editor]').forEach((form)=>{
    const initial=form.querySelector<HTMLInputElement>('[data-seller-digital-initial-file]');
    if(!initial)return;
    const type=form.querySelector<HTMLSelectElement>('select[name="type"]');
    const status=form.querySelector<HTMLElement>('[data-seller-digital-initial-upload] .file-status');
    if(!type||!status)return;
    form.addEventListener('submit',(event)=>{void (async()=>{
      if(type.value!=='digital')return;
      const submitter=event.submitter instanceof HTMLButtonElement?event.submitter:undefined;
      const intent=submitter?.value==='submit'?'submit':'save';
      const file=initial.files?.[0];
      if(!file&&intent==='submit'){
        event.preventDefault();status.textContent='Чтобы отправить цифровую карточку на модерацию, сначала выберите файл.';status.classList.add('form-error');return;
      }
      if(!file)return;
      event.preventDefault();
      const fileError=validateDigitalFile(file,20);if(fileError){status.textContent=fileError;status.classList.add('form-error');return;}
      const buttons=[...form.querySelectorAll<HTMLButtonElement>('button[type="submit"],button:not([type])')];buttons.forEach((button)=>button.disabled=true);
      status.classList.remove('form-error');status.textContent='Сохраняем карточку…';
      try{
        const params=encodedForm(form);params.set('intent',intent);
        const saveResponse=await fetch('/seller/listings',{method:'POST',headers:{'content-type':'application/x-www-form-urlencoded;charset=UTF-8','accept':'application/json','x-seller-listing-flow':'1','x-seller-digital-file-pending':'1'},body:params.toString(),credentials:'same-origin'});
        const saved=await saveResponse.json() as {ok?:boolean;error?:string;id?:string};
        if(!saveResponse.ok||!saved.ok||!saved.id)throw new Error(saved.error||'Карточка не сохранена.');
        const idField=form.querySelector<HTMLInputElement>('input[name="id"]')??document.createElement('input');if(!idField.name){idField.type='hidden';idField.name='id';form.append(idField);}idField.value=saved.id;
        status.textContent=`Проверяем и загружаем ${file.name}…`;
        const csrf=form.querySelector<HTMLInputElement>('input[name="csrfToken"]')?.value??'';
        const upload=await fetch(`/seller/listings/${encodeURIComponent(saved.id)}/digital-version`,{method:'POST',headers:{'Content-Type':file.type,'X-CSRF-Token':csrf,'X-File-Name':encodeURIComponent(file.name)},body:file,credentials:'same-origin'});
        const uploaded=await upload.json() as {ok?:boolean;error?:string};
        if(!upload.ok||!uploaded.ok)throw new Error(uploaded.error||'Файл не сохранён.');
        if(intent==='submit'){
          status.textContent='Файл сохранён. Отправляем карточку на модерацию…';
          const submitResponse=await fetch(`/seller/listings/${encodeURIComponent(saved.id)}/submit`,{method:'POST',headers:{'content-type':'application/x-www-form-urlencoded;charset=UTF-8','accept':'application/json','x-seller-submit-flow':'1'},body:new URLSearchParams({csrfToken:csrf}).toString(),credentials:'same-origin'});
          const submitted=await submitResponse.json() as {ok?:boolean;error?:string};
          if(!submitResponse.ok||!submitted.ok){window.location.assign(`/seller/listings/${encodeURIComponent(saved.id)}?submitError=${encodeURIComponent(submitted.error||'Карточка не отправлена на модерацию.')}`);return;}
        }
        window.location.assign('/seller/listings');
      }catch(error){status.textContent=error instanceof Error?error.message:'Не удалось сохранить цифровую карточку.';status.classList.add('form-error');buttons.forEach((button)=>button.disabled=false);}
    })();});
  });
}

function setupPlatformDigitalInitialFlow():void {
  document.querySelectorAll<HTMLFormElement>('form[data-platform-offer-form]').forEach((form)=>{
    const initial=form.querySelector<HTMLInputElement>('[data-platform-digital-initial-file]');
    if(!initial)return;
    const type=form.querySelector<HTMLSelectElement>('select[name="type"]');const status=form.querySelector<HTMLElement>('[data-platform-digital-initial-upload] .file-status');const state=form.querySelector<HTMLSelectElement>('select[name="status"]');
    if(!type||!status||!state)return;
    form.addEventListener('submit',(event)=>{void (async()=>{
      if(type.value!=='digital')return;
      const file=initial.files?.[0];
      if(!file&&state.value==='published'){event.preventDefault();status.textContent='Для публикации цифрового материала выберите файл.';status.classList.add('form-error');return;}
      if(!file)return;
      event.preventDefault();const fileError=validateDigitalFile(file,25);if(fileError){status.textContent=fileError;status.classList.add('form-error');return;}
      const button=event.submitter instanceof HTMLButtonElement?event.submitter:form.querySelector<HTMLButtonElement>('button[type="submit"],button:not([type])');if(button)button.disabled=true;
      try{
        const params=encodedForm(form);const requestedStatus=state.value;status.classList.remove('form-error');status.textContent='Сохраняем предложение…';
        const save=await fetch('/admin/platform-offers',{method:'POST',headers:{'content-type':'application/x-www-form-urlencoded;charset=UTF-8','accept':'application/json','x-platform-offer-flow':'1','x-platform-digital-file-pending':'1'},body:params.toString(),credentials:'same-origin'});
        const saved=await save.json() as {ok?:boolean;error?:string;id?:string;slug?:string;productId?:string};
        if(!save.ok||!saved.ok||!saved.id||!saved.slug||!saved.productId)throw new Error(saved.error||'Предложение не сохранено.');
        const idField=form.querySelector<HTMLInputElement>('input[name="id"]');if(idField)idField.value=saved.id;const slugField=form.querySelector<HTMLInputElement>('input[name="slug"]');if(slugField)slugField.value=saved.slug;
        status.textContent=`Проверяем и загружаем ${file.name}…`;const csrf=form.querySelector<HTMLInputElement>('input[name="csrf"]')?.value??'';
        const upload=await fetch(`/admin/digital-products/${encodeURIComponent(saved.productId)}/asset`,{method:'POST',headers:{'Content-Type':file.type,'X-CSRF-Token':csrf,'X-File-Name':encodeURIComponent(file.name)},body:file,credentials:'same-origin'});
        const uploaded=await upload.json() as {ok?:boolean;error?:string};if(!upload.ok||!uploaded.ok)throw new Error(uploaded.error||'Файл не сохранён.');
        if(requestedStatus==='published'){
          status.textContent='Файл сохранён. Публикуем предложение…';const finalParams=encodedForm(form);finalParams.set('status','published');
          const finalize=await fetch('/admin/platform-offers',{method:'POST',headers:{'content-type':'application/x-www-form-urlencoded;charset=UTF-8','accept':'application/json','x-platform-offer-flow':'1'},body:finalParams.toString(),credentials:'same-origin'});
          const finalResult=await finalize.json() as {ok?:boolean;error?:string};if(!finalize.ok||!finalResult.ok)throw new Error(finalResult.error||'Предложение сохранено как черновик, но не опубликовано.');
        }
        window.location.assign(`/admin/platform-offers?edit=${encodeURIComponent(saved.slug)}&saved=1`);
      }catch(error){status.textContent=error instanceof Error?error.message:'Не удалось сохранить цифровой материал.';status.classList.add('form-error');if(button)button.disabled=false;}
    })();});
  });
}

function setupDigitalAssetUpload(): void {
  document.querySelectorAll<HTMLElement>('[data-digital-asset-upload]').forEach((form) => {
    const fileInput=form.querySelector<HTMLInputElement>('input[type="file"]');
    const status=form.querySelector<HTMLElement>('.file-status');
    const submit=form.querySelector<HTMLButtonElement>('button[type="submit"], button[data-upload-digital-version], button');
    const productId=form.dataset.productId??'';
    const productSlug=form.dataset.productSlug??'';
    const csrf=form.dataset.csrf??'';
    const maxMb=Number(form.dataset.maxFileMb??'25');
    if(!fileInput||!status||!submit||!productId||!csrf)return;
    const allowed=new Map<string,string>([
      ['pdf','application/pdf'],['zip','application/zip'],
      ['docx','application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
      ['xlsx','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
      ['pptx','application/vnd.openxmlformats-officedocument.presentationml.presentation'],
      ['txt','text/plain']
    ]);
    submit.addEventListener('click',async()=>{
      const file=fileInput.files?.[0];
      if(!file){status.textContent='Выберите файл.';status.classList.add('form-error');return;}
      const ext=file.name.includes('.')?file.name.split('.').pop()!.toLowerCase():'';
      const expected=allowed.get(ext);
      if(!expected||file.type!==expected){status.textContent='Разрешены PDF, ZIP, DOCX, XLSX, PPTX и TXT с корректным типом файла.';status.classList.add('form-error');return;}
      if(file.size<1||file.size>maxMb*1024*1024){status.textContent=`Размер файла должен быть от 1 байта до ${maxMb} МБ.`;status.classList.add('form-error');return;}
      status.classList.remove('form-error');status.textContent=`Загружаем ${file.name}…`;
      submit.disabled=true;const original=submit.textContent;submit.textContent='Загружаем…';
      try{
        const response=await fetch(`/admin/digital-products/${encodeURIComponent(productId)}/asset`,{method:'POST',headers:{'Content-Type':file.type,'X-CSRF-Token':csrf,'X-File-Name':encodeURIComponent(file.name)},body:file});
        const payload=await response.json() as {ok?:boolean;error?:string;editSlug?:string};
        if(!response.ok||!payload.ok)throw new Error(payload.error||`HTTP ${response.status}`);
        status.textContent='Новая версия файла сохранена.';announce('Новая версия цифрового файла сохранена.');
        window.location.assign(`/admin/platform-offers?edit=${encodeURIComponent(payload.editSlug||productSlug)}&saved=1`);
      }catch(error){status.textContent=error instanceof Error?error.message:'Не удалось загрузить файл.';status.classList.add('form-error');submit.disabled=false;submit.textContent=original;}
    });
  });
}


function setupDigitalProductCover(): void {
  document.querySelectorAll<HTMLElement>('[data-digital-product-cover]').forEach((container) => {
    const fileInput=container.querySelector<HTMLInputElement>('[data-digital-cover-input]');
    const hidden=container.querySelector<HTMLInputElement>('input[name="coverImageData"]');
    const preview=container.querySelector<HTMLElement>('[data-digital-cover-preview]');
    const status=container.querySelector<HTMLElement>('[data-digital-cover-status]');
    if(!fileInput||!hidden||!preview||!status)return;
    fileInput.addEventListener('change',async()=>{
      const file=fileInput.files?.[0];
      hidden.value='';
      status.classList.remove('form-error');
      if(!file){status.textContent='Изображение не выбрано.';return;}
      status.textContent='Подготавливаем обложку…';
      try{
        const prepared=await resizeImage(file,1600);
        hidden.value=prepared;
        preview.innerHTML='';
        const image=document.createElement('img');
        image.src=prepared;
        image.alt='Новая обложка цифрового продукта';
        preview.append(image);
        status.textContent=`${file.name} · готово к сохранению`;
        announce('Обложка цифрового продукта подготовлена.');
      }catch(error){
        fileInput.value='';hidden.value='';status.classList.add('form-error');
        status.textContent=error instanceof Error?error.message:'Не удалось подготовить обложку.';
      }
    });
  });
}

function setupFormPendingState(): void {
  document.querySelectorAll<HTMLFormElement>('form').forEach((form) => {
    form.addEventListener('submit', (event) => {
      if (event.defaultPrevented) return;
      if (form.matches('[data-digital-asset-upload]')) return;
      if (form.dataset.mediaBlocked === '1') return;
      if (!form.checkValidity()) return;
      const nativeSubmitter = (event as SubmitEvent).submitter;
      const submitter = nativeSubmitter instanceof HTMLButtonElement
        ? nativeSubmitter
        : form.querySelector<HTMLButtonElement>('button[type="submit"], button:not([type])');
      if (!submitter || submitter.dataset.noPending === '1') return;

      // Disabled submit-кнопка не входит в отправляемые поля формы.
      // Перед блокировкой зеркалим name/value именно нажатой кнопки,
      // чтобы формы с несколькими действиями (например, принять/отклонить)
      // не теряли выбранное пользователем действие.
      let actionMirror: HTMLInputElement | undefined;
      if (submitter.name) {
        actionMirror = document.createElement('input');
        actionMirror.type = 'hidden';
        actionMirror.name = submitter.name;
        actionMirror.value = submitter.value;
        actionMirror.dataset.pendingSubmitterMirror = '1';
        form.append(actionMirror);
      }

      submitter.disabled = true;
      submitter.dataset.originalText = submitter.textContent ?? '';
      submitter.textContent = 'Отправляем…';
      window.setTimeout(() => {
        if (!document.contains(form)) return;
        actionMirror?.remove();
        submitter.disabled = false;
        submitter.textContent = submitter.dataset.originalText ?? 'Отправить';
      }, 10000);
    });
  });
}

function focusFirstError(): void {
  const error = document.querySelector<HTMLElement>('.form-error, [role="alert"]');
  if (!error) return;
  error.setAttribute('tabindex', '-1');
  error.focus({ preventScroll: true });
  error.scrollIntoView({ block: 'center', behavior: 'smooth' });
}

cleanupOneTimeQueryFlags();
setupCopyButtons();
setupDocumentFiles();
setupDigitalAssetUpload();
setupPlatformDigitalEditor();
setupListingPricing();
setupSellerDigitalEditor();
setupSellerDigitalVersionUpload();
setupSellerDigitalInitialFlow();
setupPlatformDigitalInitialFlow();
setupDigitalProductCover();
setupFormPendingState();
focusFirstError();

function setupNavigationMenus(): void {
  const button = document.querySelector<HTMLButtonElement>('[data-menu-button]');
  const menu = document.querySelector<HTMLElement>('[data-menu]');
  if (button && menu) {
    const setOpen = (open: boolean): void => {
      menu.classList.toggle('open', open);
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? 'Закрыть меню' : 'Открыть меню');
    };
    button.addEventListener('click', (event) => {
      event.stopPropagation();
      setOpen(!menu.classList.contains('open'));
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
    document.addEventListener('click', (event) => {
      if (!menu.classList.contains('open')) return;
      const target = event.target;
      if (target instanceof Node && !menu.contains(target) && !button.contains(target)) setOpen(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.classList.contains('open')) {
        setOpen(false);
        button.focus();
      }
    });
  }

  const portalButton = document.querySelector<HTMLButtonElement>('[data-portal-menu-button]');
  const portalMenu = document.querySelector<HTMLElement>('[data-portal-menu]');
  const portalBackdrop = document.querySelector<HTMLButtonElement>('[data-portal-menu-backdrop]');
  const portalClose = document.querySelector<HTMLButtonElement>('[data-portal-menu-close]');
  if (portalButton && portalMenu) {
    const setPortalOpen = (open: boolean, restoreFocus = false): void => {
      portalMenu.classList.toggle('open', open);
      portalBackdrop?.classList.toggle('open', open);
      document.body.classList.toggle('portal-menu-open', open);
      portalButton.setAttribute('aria-expanded', String(open));
      portalButton.setAttribute('aria-label', open ? 'Закрыть меню' : 'Открыть меню');
      if (!open && restoreFocus) portalButton.focus();
    };
    portalButton.addEventListener('click', () => setPortalOpen(!portalMenu.classList.contains('open')));
    portalBackdrop?.addEventListener('click', () => setPortalOpen(false, true));
    portalClose?.addEventListener('click', () => setPortalOpen(false, true));
    portalMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setPortalOpen(false)));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && portalMenu.classList.contains('open')) setPortalOpen(false, true);
    });
  }

  document.querySelectorAll<HTMLDetailsElement>('.nav-catalog[open]').forEach((details) => details.removeAttribute('open'));
  document.addEventListener('click', (event) => {
    const target = event.target;
    document.querySelectorAll<HTMLDetailsElement>('.nav-catalog[open]').forEach((details) => {
      if (target instanceof Node && !details.contains(target)) details.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll<HTMLDetailsElement>('.nav-catalog[open]').forEach((details) => details.removeAttribute('open'));
  });
}

setupNavigationMenus();

const FAVORITES_KEY = 'territoriya-rosta:favorites:v1';

function readFavorites(): Set<string> {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(FAVORITES_KEY) ?? '[]') as unknown;
    return new Set(Array.isArray(parsed) ? parsed.filter((item): item is string => typeof item === 'string') : []);
  } catch {
    return new Set();
  }
}

function writeFavorites(favorites: Set<string>): void {
  window.localStorage.setItem(FAVORITES_KEY, JSON.stringify([...favorites]));
}

function renderFavoritesState(): void {
  const favorites = readFavorites();
  document.querySelectorAll<HTMLElement>('[data-favorites-count]').forEach((node) => { node.textContent = String(favorites.size); });
  document.querySelectorAll<HTMLButtonElement>('[data-favorite-button]').forEach((button) => {
    const slug = button.dataset.favoriteSlug ?? '';
    const active = favorites.has(slug);
    button.classList.toggle('active', active);
    button.setAttribute('aria-label', active ? 'Убрать из избранного' : 'Добавить в избранное');
    if (button.classList.contains('favorite-offer-button')) {
      button.lastChild && (button.lastChild.textContent = active ? ' В избранном' : ' Сохранить в избранное');
    }
  });
  const view = document.querySelector<HTMLElement>('[data-favorites-view]');
  if (view) {
    let visible = 0;
    view.querySelectorAll<HTMLElement>('[data-listing-card]').forEach((card) => {
      const show = favorites.has(card.dataset.listingSlug ?? '');
      card.hidden = !show;
      if (show) visible += 1;
    });
    const empty = document.querySelector<HTMLElement>('[data-favorites-empty]');
    if (empty) empty.hidden = visible > 0;
  }
}

function setupFavorites(): void {
  document.querySelectorAll<HTMLButtonElement>('[data-favorite-button]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const slug = button.dataset.favoriteSlug ?? '';
      if (!slug) return;
      const favorites = readFavorites();
      if (favorites.has(slug)) {
        favorites.delete(slug);
        announce('Карточка удалена из избранного.');
      } else {
        favorites.add(slug);
        announce('Карточка добавлена в избранное.');
      }
      writeFavorites(favorites);
      renderFavoritesState();
    });
  });
  renderFavoritesState();
}

const COMPARE_KEY = 'territoriya-rosta:compare:v1';
const COMPARE_LIMIT = 4;

function readCompare(): Set<string> {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(COMPARE_KEY) ?? '[]') as unknown;
    return new Set(Array.isArray(parsed) ? parsed.filter((item): item is string => typeof item === 'string').slice(0, COMPARE_LIMIT) : []);
  } catch {
    return new Set();
  }
}

function writeCompare(items: Set<string>): void {
  window.localStorage.setItem(COMPARE_KEY, JSON.stringify([...items].slice(0, COMPARE_LIMIT)));
}

function renderCompareState(): void {
  const items = readCompare();
  document.querySelectorAll<HTMLElement>('[data-compare-count]').forEach((node) => { node.textContent = String(items.size); });
  document.querySelectorAll<HTMLButtonElement>('[data-compare-button]').forEach((button) => {
    const slug = button.dataset.compareSlug ?? '';
    const active = items.has(slug);
    button.classList.toggle('active', active);
    button.setAttribute('aria-label', active ? 'Убрать из сравнения' : 'Добавить к сравнению');
    if (button.classList.contains('compare-offer-button')) {
      button.lastChild && (button.lastChild.textContent = active ? ' В сравнении' : ' Сравнить');
    }
  });
  const view = document.querySelector<HTMLElement>('[data-compare-view]');
  if (view) {
    let visible = 0;
    view.querySelectorAll<HTMLElement>('[data-compare-card]').forEach((card) => {
      const show = items.has(card.dataset.compareSlug ?? '');
      card.hidden = !show;
      if (show) visible += 1;
    });
    const empty = document.querySelector<HTMLElement>('[data-compare-empty]');
    if (empty) empty.hidden = visible > 0;
  }
}

function setupCompare(): void {
  document.querySelectorAll<HTMLButtonElement>('[data-compare-button]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const slug = button.dataset.compareSlug ?? '';
      if (!slug) return;
      const items = readCompare();
      if (items.has(slug)) {
        items.delete(slug);
        announce('Карточка удалена из сравнения.');
      } else if (items.size >= COMPARE_LIMIT) {
        announce('Можно сравнить не более четырёх карточек.');
        return;
      } else {
        items.add(slug);
        announce('Карточка добавлена к сравнению.');
        writeCompare(items);
        renderCompareState();
        if (!document.querySelector('[data-compare-view]')) window.location.assign('/compare');
        return;
      }
      writeCompare(items);
      renderCompareState();
    });
  });
  renderCompareState();
}

type PreparedImageSource = { source: CanvasImageSource; width: number; height: number; release: () => void };

async function prepareImageSource(file: File): Promise<PreparedImageSource> {
  if (typeof createImageBitmap === 'function') {
    try {
      const bitmap = await createImageBitmap(file);
      return { source: bitmap, width: bitmap.width, height: bitmap.height, release: () => bitmap.close() };
    } catch {
      // Some valid JPG/PNG/WebP files are rejected by createImageBitmap in individual browsers.
      // Fall back to the regular image decoder instead of silently losing the selected logo.
    }
  }

  const objectUrl = URL.createObjectURL(file);
  try {
    const image = await new Promise<HTMLImageElement>((resolve, reject) => {
      const element = new Image();
      element.addEventListener('load', () => resolve(element), { once: true });
      element.addEventListener('error', () => reject(new Error('Браузер не смог прочитать изображение.')), { once: true });
      element.src = objectUrl;
    });
    return { source: image, width: image.naturalWidth, height: image.naturalHeight, release: () => URL.revokeObjectURL(objectUrl) };
  } catch (error) {
    URL.revokeObjectURL(objectUrl);
    throw error;
  }
}

async function resizeImage(file: File, maxDimension: number): Promise<string> {
  if (!/^image\/(jpeg|png|webp)$/i.test(file.type)) throw new Error('Поддерживаются JPG, PNG и WebP.');
  if (file.size > 8 * 1024 * 1024) throw new Error('Исходный файл больше 8 МБ.');
  const prepared = await prepareImageSource(file);
  try {
    const scale = Math.min(1, maxDimension / Math.max(prepared.width, prepared.height));
    const width = Math.max(1, Math.round(prepared.width * scale));
    const height = Math.max(1, Math.round(prepared.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Браузер не смог подготовить изображение.');
    context.drawImage(prepared.source, 0, 0, width, height);
    let quality = 0.86;
    let result = canvas.toDataURL('image/jpeg', quality);
    while (result.length > 1_150_000 && quality > 0.5) {
      quality -= 0.08;
      result = canvas.toDataURL('image/jpeg', quality);
    }
    if (result.length > 1_300_000) throw new Error('Изображение не удалось достаточно уменьшить.');
    return result;
  } finally {
    prepared.release();
  }
}

async function readVideo(file: File, maxBytes: number): Promise<string> {
  if (!/^video\/(mp4|webm)$/i.test(file.type)) throw new Error('Поддерживаются видео MP4 и WebM.');
  if (file.size > maxBytes) throw new Error('Видео больше 12 МБ. Выберите более короткий или сжатый файл.');
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => typeof reader.result === 'string' ? resolve(reader.result) : reject(new Error('Не удалось прочитать видео.'));
    reader.onerror = () => reject(new Error('Не удалось прочитать видео.'));
    reader.readAsDataURL(file);
  });
}

function setupMediaForms(): void {
  const busyTokens = new WeakMap<HTMLFormElement, Set<string>>();
  const setBusy = (form: HTMLFormElement, token: string, busy: boolean) => {
    const tokens = busyTokens.get(form) ?? new Set<string>();
    if (busy) tokens.add(token); else tokens.delete(token);
    busyTokens.set(form, tokens);
    const blocked = tokens.size > 0;
    form.dataset.mediaBlocked = blocked ? '1' : '0';
    const submitters = form.querySelectorAll<HTMLButtonElement>('button[type="submit"], button:not([type])');
    submitters.forEach((button) => { button.disabled = blocked; });
  };
  const blockSubmitWhileBusy = (form: HTMLFormElement, status: HTMLElement) => {
    form.addEventListener('submit', (event) => {
      if (form.dataset.mediaBlocked === '1') {
        event.preventDefault();
        status.textContent = 'Дождитесь подготовки медиафайлов перед сохранением.';
        status.classList.add('form-error');
        announce('Дождитесь подготовки медиафайлов.');
      }
    });
  };

  document.querySelectorAll<HTMLFormElement>('.media-data-form').forEach((form) => {
    const input = form.querySelector<HTMLInputElement>('[data-media-role="single"]');
    const output = form.querySelector<HTMLInputElement>('[data-media-output]');
    const mime = form.querySelector<HTMLInputElement>('[data-media-mime]');
    const preview = form.querySelector<HTMLElement>('[data-media-preview]');
    const status = form.querySelector<HTMLElement>('[data-logo-media-status]') ?? form.querySelector<HTMLElement>('.media-status');
    const remove = form.querySelector<HTMLButtonElement>('[data-media-remove]');
    const touched = form.querySelector<HTMLInputElement>('[data-media-touched]');
    if (!input || !output || !mime || !preview || !status) return;
    let selectedFilePrepared = false;

    input.addEventListener('change', async () => {
      const file = input.files?.[0];
      selectedFilePrepared = false;
      status.classList.remove('form-error');
      if (!file) return;
      setBusy(form, 'single', true);
      status.textContent = 'Подготавливаем логотип…';
      try {
        const data = await resizeImage(file, Number(input.dataset.maxDimension ?? 700));
        output.value = data;
        mime.value = 'image/jpeg';
        if (touched) touched.value = '1';
        selectedFilePrepared = true;
        preview.innerHTML = `<img class="profile-logo-preview" src="${data}" alt="Предпросмотр логотипа">`;
        if (remove) remove.hidden = false;
        input.value = '';
        status.textContent = 'Логотип подготовлен. Сохраните изменения.';
      } catch (error) {
        input.value = '';
        status.textContent = error instanceof Error ? error.message : 'Не удалось обработать изображение.';
        status.classList.add('form-error');
      } finally {
        setBusy(form, 'single', false);
      }
    });
    remove?.addEventListener('click', () => {
      if (form.dataset.mediaBlocked === '1') return;
      input.value = '';
      output.value = '';
      mime.value = '';
      if (touched) touched.value = '1';
      preview.innerHTML = '<span>Логотип будет удалён после сохранения</span>';
      remove.hidden = true;
      status.classList.remove('form-error');
      status.textContent = 'Логотип отмечен для удаления. Сохраните изменения.';
      form.dispatchEvent(new Event('input', { bubbles: true }));
    });
    blockSubmitWhileBusy(form, status);
    form.addEventListener('submit', (event) => {
      if ((input.files?.length ?? 0) > 0 && !selectedFilePrepared) {
        event.preventDefault();
        status.textContent = 'Логотип ещё не подготовлен. Выберите файл повторно.';
        status.classList.add('form-error');
        announce('Логотип не подготовлен.');
      }
    });
  });

  document.querySelectorAll<HTMLFormElement>('.listing-media-form').forEach((form) => {
    const coverInput = form.querySelector<HTMLInputElement>('[data-media-role="cover"]');
    const coverOutput = form.querySelector<HTMLInputElement>('[data-cover-output]');
    const coverMime = form.querySelector<HTMLInputElement>('[data-cover-mime]');
    const coverPreview = form.querySelector<HTMLElement>('[data-cover-preview]');
    const coverRemove = form.querySelector<HTMLButtonElement>('[data-cover-remove]');
    const coverTouched = form.querySelector<HTMLInputElement>('[data-cover-touched]');
    const galleryInput = form.querySelector<HTMLInputElement>('[data-media-role="gallery"]');
    const galleryOutput = form.querySelector<HTMLInputElement>('[data-gallery-output]');
    const galleryPreview = form.querySelector<HTMLElement>('[data-gallery-preview]');
    const status = form.querySelector<HTMLElement>('[data-listing-media-status]') ?? form.querySelector<HTMLElement>('.media-status');
    const videoInput = form.querySelector<HTMLInputElement>('[data-media-role="video"]');
    const videoOutput = form.querySelector<HTMLInputElement>('[data-video-output]');
    const videoMime = form.querySelector<HTMLInputElement>('[data-video-mime]');
    const videoName = form.querySelector<HTMLInputElement>('[data-video-name]');
    const videoTouched = form.querySelector<HTMLInputElement>('[data-video-touched]');
    const videoPreview = form.querySelector<HTMLElement>('[data-video-preview]');
    const videoRemove = form.querySelector<HTMLButtonElement>('[data-video-remove]');
    const videoStatus = form.querySelector<HTMLElement>('.video-status');
    if (!coverInput || !coverOutput || !coverMime || !coverPreview || !galleryInput || !galleryOutput || !galleryPreview || !status) return;

    coverInput.addEventListener('change', async () => {
      const file = coverInput.files?.[0];
      if (!file) return;
      status.classList.remove('form-error');
      setBusy(form, 'cover', true);
      status.textContent = 'Подготавливаем обложку…';
      try {
        const data = await resizeImage(file, Number(coverInput.dataset.maxDimension ?? 1600));
        coverOutput.value = data;
        coverMime.value = 'image/jpeg';
        if (coverTouched) coverTouched.value = '1';
        coverPreview.innerHTML = `<img src="${data}" alt="Предпросмотр обложки">`;
        if (coverRemove) coverRemove.hidden = false;
        coverInput.value = '';
        status.textContent = 'Обложка подготовлена.';
        form.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (error) {
        coverInput.value = '';
        status.textContent = error instanceof Error ? error.message : 'Не удалось обработать обложку.';
        status.classList.add('form-error');
      } finally {
        setBusy(form, 'cover', false);
      }
    });
    coverRemove?.addEventListener('click', () => {
      if (form.dataset.mediaBlocked === '1') return;
      coverInput.value = '';
      coverOutput.value = '';
      coverMime.value = '';
      if (coverTouched) coverTouched.value = '1';
      coverPreview.innerHTML = '<span>Обложка будет удалена после сохранения</span>';
      coverRemove.hidden = true;
      status.classList.remove('form-error');
      status.textContent = 'Обложка отмечена для удаления. Сохраните карточку.';
      form.dispatchEvent(new Event('input', { bubbles: true }));
    });

    const readGallery = (): string[] => {
      try {
        const parsed = JSON.parse(galleryOutput.value || '[]') as unknown;
        return Array.isArray(parsed) ? parsed.filter((item): item is string => typeof item === 'string').slice(0, 4) : [];
      } catch { return []; }
    };
    const renderGalleryPreview = (images: string[]) => {
      galleryPreview.innerHTML = images.map((data, index) => `<span class="gallery-preview-item"><img src="${data}" alt="Изображение ${index + 1}"><button type="button" class="gallery-remove" data-gallery-remove="${index}" aria-label="Удалить изображение">×</button></span>`).join('');
    };
    renderGalleryPreview(readGallery());
    galleryInput.addEventListener('change', async () => {
      const current = readGallery();
      const remaining = Math.max(0, 4 - current.length);
      const files = [...(galleryInput.files ?? [])].slice(0, remaining);
      if (!files.length) {
        if (remaining === 0) status.textContent = 'В галерее уже четыре изображения. Удалите одно, чтобы заменить его.';
        return;
      }
      status.classList.remove('form-error');
      setBusy(form, 'gallery', true);
      galleryPreview.dataset.mediaBusy = '1';
      status.textContent = 'Подготавливаем галерею…';
      try {
        const images = [...current];
        for (const file of files) images.push(await resizeImage(file, Number(galleryInput.dataset.maxDimension ?? 1400)));
        galleryOutput.value = JSON.stringify(images.slice(0, 4));
        renderGalleryPreview(images.slice(0, 4));
        galleryInput.value = '';
        status.textContent = `Галерея подготовлена: ${Math.min(images.length, 4)} из 4 изображений.`;
        form.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (error) {
        galleryInput.value = '';
        status.textContent = error instanceof Error ? error.message : 'Не удалось обработать галерею.';
        status.classList.add('form-error');
      } finally {
        delete galleryPreview.dataset.mediaBusy;
        setBusy(form, 'gallery', false);
      }
    });
    galleryPreview.addEventListener('click', (event) => {
      if (galleryPreview.dataset.mediaBusy === '1') return;
      const target = (event.target as HTMLElement).closest<HTMLButtonElement>('[data-gallery-remove]');
      if (!target) return;
      const index = Number(target.dataset.galleryRemove);
      const images = readGallery();
      if (!Number.isInteger(index) || index < 0 || index >= images.length) return;
      images.splice(index, 1);
      galleryOutput.value = JSON.stringify(images);
      renderGalleryPreview(images);
      status.textContent = `В галерее ${images.length} из 4 изображений.`;
      form.dispatchEvent(new Event('input', { bubbles: true }));
    });

    if (videoInput && videoOutput && videoMime && videoName && videoTouched && videoPreview && videoRemove && videoStatus) {
      videoInput.addEventListener('change', async () => {
        const file = videoInput.files?.[0];
        if (!file) return;
        videoStatus.classList.remove('form-error');
        setBusy(form, 'video', true);
        videoStatus.textContent = 'Подготавливаем видео…';
        try {
          const data = await readVideo(file, Number(videoInput.dataset.maxBytes ?? 12582912));
          videoOutput.value = data;
          videoMime.value = file.type.toLowerCase();
          videoName.value = file.name;
          videoTouched.value = '1';
          videoPreview.innerHTML = `<video controls preload="metadata" src="${data}"></video>`;
          videoRemove.hidden = false;
          videoInput.value = '';
          videoStatus.textContent = `Видео подготовлено: ${file.name}. Сохраните карточку.`;
        } catch (error) {
          videoInput.value = '';
          videoStatus.textContent = error instanceof Error ? error.message : 'Не удалось обработать видео.';
          videoStatus.classList.add('form-error');
        } finally {
          setBusy(form, 'video', false);
        }
      });
      videoRemove.addEventListener('click', () => {
        if (form.dataset.mediaBlocked === '1') return;
        videoInput.value = '';
        videoOutput.value = '';
        videoMime.value = '';
        videoName.value = '';
        videoTouched.value = '1';
        videoPreview.innerHTML = '<span>Видео будет удалено после сохранения карточки</span>';
        videoRemove.hidden = true;
        videoStatus.classList.remove('form-error');
        videoStatus.textContent = 'Видео отмечено для удаления. Сохраните карточку.';
      });
    }
    blockSubmitWhileBusy(form, status);
  });
}

function setupOfferGallery(): void {
  const main = document.querySelector<HTMLImageElement>('[data-gallery-main]');
  if (!main) return;
  document.querySelectorAll<HTMLButtonElement>('[data-gallery-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const src = button.dataset.gallerySrc;
      if (!src) return;
      main.src = src;
      document.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('active'));
      button.classList.add('active');
    });
  });
}

setupFavorites();
setupCompare();
setupMediaForms();

function setupListingAutosave(): void {
  document.querySelectorAll<HTMLFormElement>('.listing-media-form[data-autosave-url]').forEach((form) => {
    const url=form.dataset.autosaveUrl;
    if(!url)return;
    const versionField=form.querySelector<HTMLInputElement>('[name="draftVersion"]');
    const status=form.querySelector<HTMLElement>('[data-draft-status]');
    let timer:number|undefined;
    let saving=false;
    let dirty=false;
    const save=async()=>{
      if(saving){dirty=true;return;}
      saving=true;
      dirty=false;
      if(status)status.textContent='Сохраняем черновик…';
      try{
        const params=new URLSearchParams();
        const data=new FormData(form);
        const allowed=new Set(['csrfToken','id','title','slug','categorySlug','type','summary','description','priceMode','priceRub','delivery','attributes','featured','coverImageData','coverImageMimeType','galleryImages','draftKey','draftVersion']);
        for(const [key,value] of data.entries())if(allowed.has(key)&&typeof value==='string')params.append(key,value);
        const response=await fetch(url,{method:'POST',headers:{'content-type':'application/x-www-form-urlencoded;charset=UTF-8','accept':'application/json'},body:params.toString(),credentials:'same-origin'});
        const contentType=response.headers.get('content-type')??'';
        let result:{version?:number;error?:string}={};
        if(contentType.includes('application/json')){
          result=await response.json() as {version?:number;error?:string};
        }else{
          const message=(await response.text()).trim();
          if(!response.ok)throw new Error(message||'Не удалось сохранить черновик.');
          throw new Error('Сервер вернул неожиданный ответ при автосохранении.');
        }
        if(!response.ok)throw new Error(result.error||'Не удалось сохранить черновик.');
        if(versionField&&typeof result.version==='number')versionField.value=String(result.version);
        if(status)status.textContent='Черновик сохранён автоматически.';
      }catch(error){if(status){status.textContent=error instanceof Error?error.message:'Автосохранение не сработало.';status.classList.add('form-error');}}
      finally{saving=false;if(dirty)window.setTimeout(()=>void save(),0);}
    };
    form.addEventListener('input',()=>{dirty=true;if(status)status.classList.remove('form-error');if(timer)window.clearTimeout(timer);timer=window.setTimeout(()=>void save(),1200);});
  });
}

setupListingAutosave();
setupOfferGallery();


function setupMonetizationFilters(): void {
  document.querySelectorAll<HTMLSelectElement>('[data-auto-submit-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const form=select.closest<HTMLFormElement>('form[data-auto-submit-filter]');
      if(form) form.requestSubmit();
    });
  });
}

setupMonetizationFilters();
